// extracted by css-extract-rspack-plugin
export default {"separatorBlock":"lKzhM61B","separatorVariantSubheader":"y0j50S3H"};